import React from 'react';
import PointsComponent from '../components/PointsComponent';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as modalActs from '../../../Actions/Modal';
import * as indexActs from '../../../Actions/Dashboard';

import { sendService, answerOk, sendFile } from "../../../Services/service";

import '../style.css'

class PointsContainer extends React.Component {
  state = {
    resizeObserver: null,
    file: null,
    fileError: false,
    map: null,
    upload: false,
    uploadOk: false,
    loading: false,
    pestana: 'ver',
    name: '',
    nameError: false,
    punto: null,
    puntoError: false,
    pin: null,
    pinError: false,
    change: false,
    added: false,
    pinText: '',
    pinTextError: false,
    hasPin: false,
    hasPinError: false,
    pinName: '',
    pines: [],
    puntos: [],
  }

  // editText

  selectTab = tab => {
    this.setState({ pestana: tab, upload: false, uploadOk: false })
    if (tab === 'ver' && this.state.added) this.getPoints()
  }
  changeAddSelect = option => this.setState({ pin: option, pinError: false, upload: false, uploadOk: false })
  handlerTextPunto = e => this.setState({ name: e.target.value, nameError: false, upload: false, uploadOk: false })
  activeAllPuntos = act => this.setState({ puntos: this.state.puntos.map(p => { return { ...p, active: act } }) })
  activePunto = (i, act) => this.setState({
    puntos: this.state.puntos.map((p, index) => {
      if (index === i) return { ...p, active: act }
      return { ...p }
    })
  })


  fileChange = e => {
    const img = new Image();
    const canvas = document.getElementById('canvas-pin');
    const ctx = canvas.getContext('2d');

    img.onload = function () {
      console.log(img.height, img.width);
      let height = 0;
      let width = 0;
      if (img.height >= img.width) {
        height = 40;
        width = 35 * img.width / img.height;
      } else {
        width = 35;
        height = 40 * img.height / img.width
      }
      canvas.width = width;
      canvas.height = height;
      console.log('w - h', width, height);
      ctx.drawImage(img, 0, 0, width, height);
      URL.revokeObjectURL(img.src)
    };

    img.src = URL.createObjectURL(e.target.files[0]);
    this.setState({ hasPin: true, pinName: e.target.files[0].name, upload: false, uploadOk: false })
  }

  sendPinFile = () => {
    const state = {
      pinTextError: this.errorCheck('pinText'),
      hasPinError: this.errorCheck('hasPin'),
    }
    const error = Object.keys(state).reduce((pre, cur) => pre || state[cur], false)
    this.setState({ ...state })
    if (error) return
    this.setState({ loading:true })

    const canvas = document.getElementById('canvas-pin');
    canvas.toBlob(blob => {
      const file = new File([blob], "image.png", { type: "image/png", lastModified: new Date().getTime() })
      const data = new FormData()
      data.append('file', file)
      data.append('name', this.state.pinText)
      const fileSended = (ok) => {
        if (ok) {
          this.getPins()
        }
        const canvas = document.getElementById('canvas-pin');
        const ctx = canvas.getContext('2d');
        // ctx.fillStyle = "red";
        ctx.clearRect(0, 0, 35, 40);
        this.setState({
          pinText: '',
          pinTextError: false,
          hasPin: false,
          hasPinError: false,
        })
      }
      const fileOk = () => { fileSended(true) }
      const fileError = () => { fileSended(false) }
      const funcs = {
        start: () => { },
        end: fileOk,
        onprogress: () => { },
        error: fileError
      }
      let url = `/api/v1/geo/addCustomPin`;
      sendFile(url, data, funcs);

    }, 'image/png', 1);
  }
  fileSelect = () => document.getElementById('pin-input-file').click()
  handlerText = e => this.setState({ pinText: e.target.value, upload: false, uploadOk: false })

  clearSelectPointElements = () => {
    const root = document.getElementById('root')
    const top = document.getElementById('div-top')
    const left = document.getElementById('div-left')
    const rigth = document.getElementById('div-rigth')
    root.removeChild(top)
    root.removeChild(left)
    root.removeChild(rigth)
    const modal = document.getElementsByClassName('modal-back')[0]
    modal.style.display = 'block'
  }

  dobleClickTextHandler = (variable, id)=>{
    this.setState({[variable]: this.state[variable].map((item, index) => {
      if(index === id) return {...item, edit:true}
      return {...item}
    })})
  }

  updatePoint = async (id, text) => {
    this.setState({ loading: true, puntos: [] })
    let url = `/api/v1/geo/updatePoints/${id}/${text}`
    await sendService(url);
    this.getPoints();
  }

  cancelPoint = (id) => {
    this.setState({puntos: this.state.puntos.map(item => {
      if(item.id === id) return {...item, edit:false}
      return {...item}
    })})
  }

  deletePoint = async id => {
    const del = window.confirm('¿Está seguro que desea eliminar el punto?');
    if(!del) return;
    this.setState({ loading: true, puntos: [] })
    let url = `/api/v1/geo/deletePoint/${id}`
    await sendService(url);
    this.getPoints();
  }

  selectPointOnMap = () => {
    if (!this.state.pin) {
      window.alert('Primero seleccione pin');
      return;
    }
    const modal = document.getElementsByClassName('modal-back')[0]
    modal.style.display = 'none'
    const divTop = document.createElement('div')
    divTop.classList.add('black-screen')
    divTop.id = 'div-top'
    const divLeft = document.createElement('div')
    divLeft.classList.add('black-screen')
    divLeft.id = 'div-left'
    const divRigth = document.createElement('div')
    divRigth.classList.add('black-screen')
    divRigth.id = 'div-rigth'
    const map = document.getElementById('map');
    const resizeObserver = new ResizeObserver(this.mapResize);
    resizeObserver.observe(map);
    document.getElementById('root').appendChild(divTop)
    document.getElementById('root').appendChild(divLeft)
    document.getElementById('root').appendChild(divRigth)
    this.mapResize()
    this.props.dashActions.signalPoint(this.state.pin);
    this.setState({ resizeObserver, map })

  }

  componentWillUnmount() {
    try { this.state.resizeObserver.unobserve(this.state.map) } catch (error) { }
    this.props.dashActions.pointsToShow(this.state.puntos)
  }

  componentDidUpdate(prevProps) {
    if (!this.props.dashboard.openAddedPoint && (prevProps.dashboard.openAddedPoint !== this.props.dashboard.openAddedPoint)) {
      this.clearSelectPointElements()
      this.setState({ punto: this.props.dashboard.addedPoint, upload: false, uploadOk: false })
    }
  }

  componentDidMount() {
    if (!this.props.dashboard.pointsToShow.length) this.getPoints()
    else this.setState({ puntos: this.props.dashboard.pointsToShow })
    this.getPins();
  }

  getPoints = async () => {
    this.setState({ loading: true })
    let url = '/api/v1/geo/getPoints'
    var res = await sendService(url);
    if (!answerOk(res, () => this.setState({ upload: true, uploadOk: false }))) return
    this.setState({
      loading: false,
      added: false,
      upload: false,
      uploadOk: false,
      puntos: res.response.map(p => { return { ...p, active: true, edit: false } })
    })
  }

  getPins = async () => {
    this.setState({ loading: true })
    let url = '/api/v1/geo/getPins'
    var res = await sendService(url);
    if (!answerOk(res, () => this.setState({ upload: true, uploadOk: false }))) return
    this.setState({
      pines:  res.response,
      loading: false
    })
  }

  mapResize = () => {
    const mapaBound = document.getElementById('map').getBoundingClientRect()
    const divTop = document.getElementById('div-top')
    divTop.style.height = mapaBound.top + 'px'
    const divLeft = document.getElementById('div-left')
    divLeft.style.top = mapaBound.top + 'px'
    divLeft.style.width = mapaBound.left + 'px'
    const divRigth = document.getElementById('div-rigth')
    divRigth.style.top = mapaBound.top + 'px'
    divRigth.style.left = (mapaBound.left + mapaBound.width) + 'px'
  }


  savePoint = async () => {
    const state = {
      pinError: this.errorCheck('pin'),
      nameError: this.errorCheck('name'),
      puntoError: this.errorCheck('punto'),
    }
    const error = Object.keys(state).reduce((pre, cur) => pre || state[cur], false)
    this.setState({ ...state })
    if (error) return
    this.setState({ loading: true })
    const data = {
      ...this.state.punto,
      icon: this.state.pin.icon,
      text: this.state.name
    }
    console.log('sin error', data)
    let url = '/api/v1/geo/addPoint'
    var res = await sendService(url, "POST", data);
    if (!answerOk(res, () => this.setState({ upload: true, uploadOk: false }))) return
    console.log(res)
    this.setState({
      loading: false,
      upload: true,
      uploadOk: true,
      added: true,
      name: '',
      punto: null,
    })
  }

  errorCheck = key => (!this.state[key] || this.state[key] === '')


  render() {
    return (
      <PointsComponent
        close={this.props.modalActions.closeModal}
        state={this.state}
        selectTab={this.selectTab}
        handlerDobleClick={this.dobleClickTextHandler}
        activePunto={this.activePunto}
        activeAllPuntos={this.activeAllPuntos}
        updatePoint={this.updatePoint}
        cancelPoint={this.cancelPoint}
        deletePoint={this.deletePoint}
        //Add
        changeAddSelect={this.changeAddSelect}
        selectPointOnMap={this.selectPointOnMap}
        handlerTextPunto={this.handlerTextPunto}
        savePoint={this.savePoint}
        fileSelect={this.fileSelect}
        fileChange={this.fileChange}
        handlerText={this.handlerText}
        saveCustomPin={this.sendPinFile}
      />
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    modalActions: bindActionCreators(modalActs, dispatch),
    dashActions: bindActionCreators(indexActs, dispatch)
  }
}

function mapStateToProps(state) {
  return {
    dashboard: state.dashboard,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PointsContainer);
